import { IcoChevronDown16 } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
import type React from 'react';
import { forwardRef } from 'react';

type BaseSelectTriggerProps = {
  children: React.ReactNode | string;
  hasError?: boolean;
  hasFocus?: boolean;
  isEmpty?: boolean;
  isPrivate?: boolean;
  onClick?: () => void;
  size?: 'compact' | 'default' | 'tiny';
  testID?: string;
  hasIcon?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const BaseSelectTrigger = forwardRef<HTMLButtonElement, BaseSelectTriggerProps>(
  (
    {
      children,
      disabled,
      hasError,
      hasFocus,
      isEmpty,
      isPrivate,
      onClick,
      size = 'default',
      testID,
      hasIcon,
      className,
      ...props
    }: BaseSelectTriggerProps,
    ref,
  ) => (
    <button
      data-has-error={hasError}
      data-has-focus={hasFocus}
      data-empty={isEmpty}
      {...(isPrivate && { 'data-dd-privacy': 'mask' })}
      data-testid={testID}
      data-size={size}
      disabled={disabled}
      onClick={onClick}
      ref={ref}
      type="button"
      {...props}
      /** Do not change/remove these classes */
      className={cx('fp-input fp-select-trigger fp-custom-appearance', className)}
    >
      <span
        className="flex items-center overflow-hidden max-w-[calc(100%-28px)]"
        data-testid={testID}
        {...(isPrivate && { 'data-dd-privacy': 'mask' })}
      >
        {hasIcon ? children : <p className="overflow-hidden text-ellipsis whitespace-nowrap">{children}</p>}
      </span>
      <div className="flex items-center justify-center ml-3">
        <IcoChevronDown16 color={disabled ? 'tertiary' : 'primary'} />
      </div>
    </button>
  ),
);

export default BaseSelectTrigger;
